import { ChatInputBody } from "@/modules/chats/components/chat-input/chat-input-body"
import { ChatHistoryProvider } from "@/modules/chats/hooks/useChatHistory"
import { ChatInputProvider } from "@/modules/chats/stores/useChatInputStore"
import { ChatThread } from "@/modules/chats/types/chat-thread"

type ChatInputProps = { selectedThread: ChatThread }
export const ChatInput = (props: ChatInputProps) => {
  const { selectedThread } = props

  return (
    <ChatInputProvider>
      <ChatHistoryProvider>
        <ChatInputBody selectedThread={selectedThread} />
      </ChatHistoryProvider>
    </ChatInputProvider>
  )
}
